var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructors01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m562.2,153c31.37,9.13,61.9,19.64,85.96,43.52,40.59,40.28,57.71,88.77,46.14,144.56-12.15,58.56-48.02,97.7-105.08,118.55-99.6,36.39-220.93-47.37-204.62-172.66,8.16-62.69,59.15-115.82,125.53-130.86,2.89-.65,5.6-2.05,8.4-3.11,14.56,0,29.12,0,43.68,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m539.69,951.66c-80.55,0-161.11.06-241.66-.02-39.33-.04-63.61-21.72-64.03-60.33-.8-73.26-1.53-146.58.62-219.79,2.15-73.23,46.23-120.21,118.46-131.49,15.85-2.48,31.76-4.64,47.58-7.34,23.83-4.07,25.5-3.24,33.95,19.9,28.95,79.25,57.95,158.49,86.77,237.79,3.49,9.6,6.47,18.96,19.29,18.73,12.62-.23,15.62-9.47,19.1-19.11,28.85-79.84,57.92-159.6,86.95-239.38,7.62-20.95,10.03-22.33,32.01-18.09,27.38,5.27,56.17,6.96,81.78,16.86,52.98,20.47,83.56,61.52,85.32,118.8,2.27,74.24,1.62,148.6.92,222.9-.37,38.71-24.59,60.52-63.84,60.56-81.07.09-162.15.03-243.22.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m542.84,515.47c12.07,5.12,28.13,7.1,35.26,16.12,10.15,12.84-5.24,24.25-12.03,35.19-6.11,9.86-10.87,18.65-7.9,31.53,3.94,17.06,3.88,34.99,6.79,52.34,4.55,27.14-9.73,49.26-19.14,72.31-4.34,10.63-9.97,2.8-13.39-3.77-16.94-32.56-20.35-66.56-12.34-102.22,4.6-20.49,5.44-40.08-10.24-58.05-5.77-6.62-9.23-19.23-7.32-27.65,2.94-12.96,16.77-11.14,27.61-11.42,3.63-.09,7.27-.01,10.9-.01.6-1.46,1.2-2.91,1.8-4.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructors01);
export default __webpack_public_path__ + "static/media/instructors-01.e200952eedaf35736bc68b03adc2169f.svg";
export { ForwardRef as ReactComponent };